/**
 * Screen-reader announcements (CAP-10). Flows and screens call `announce()`;
 * the shell mounts react-ui's LiveAnnouncer (one polite + one assertive
 * region) subscribed through `onAnnounce`. Messages are already translated.
 */

export type Politeness = "polite" | "assertive";

export interface Announcement {
  message: string;
  politeness: Politeness;
}

type Listener = (a: Announcement) => void;

const listeners = new Set<Listener>();

export function announce(message: string, politeness: Politeness = "polite"): void {
  if (!message) return;
  for (const l of listeners) l({ message, politeness });
}

export function onAnnounce(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
